<template>
  <div>
    <b-modal
      id="seeProductsModal"
      cancel-variant="outline-secondary"
      centered
      :title="$t('products')"
      size="lg"
      hide-footer
    >
  
      <b-table
        small
        :fields="fields"
        :items="seeProducts"
        responsive
        :tbody-tr-class="['tableRowClass']"
        class="mt-2"
        sticky-header="400px"
        :no-border-collapse="true"
        show-empty
        :empty-text="$t('empty_text')"
      >
        <template #head()="props">
          <span>{{ $t(props.label) }}</span>
        </template>
        
        <template #cell(numeration)="data">
          <span>
            {{ data.index + 1 }}
          </span>
        </template>

        <template #cell(title)="data">
          <span>
            {{ data.item }}
          </span>
        </template>


      </b-table>

    </b-modal>
  </div>
</template>

<script>
import {
  BButton, BModal, VBModal, BTable,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BButton,
    BModal,
    BTable,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  props: {
    seeProducts: {
      type: [Array],
    },
  },
  data() {
    return {
      fields: [
        {
          label: '№',
          key: 'numeration',
        },
        {
          label: 'title',
          key: 'title',
        },
      ],
    }
  },
  async mounted() {
    
  },
  computed: {

  },
  methods: {
    
  },
}
</script>

<style lang="scss">

</style>
